<template>
  <div>
    <div class="oa-activiti" id="oa-activiti">
      <a-spin
        v-if="aSpin"
        tip="流程图正在加载中 请稍后..."
        class="activiti-spin"
      />
      <div class="zoom-activiti">
        <div class="status-prompt-past">
          <a-button type="primary" ghost @click="zommBpmn('large')"
            ><a-icon type="fullscreen" />放大视图</a-button
          >
        </div>
        <div class="status-prompt-past">
          <a-button type="primary" ghost @click="zommBpmn('small')"
            ><a-icon type="fullscreen-exit" />缩小视图</a-button
          >
        </div>
        <div class="status-prompt-past">
          <a-button type="primary" ghost @click="zommBpmn('reset')"
            ><a-icon type="redo" />重置视图</a-button
          >
        </div>
      </div>
      <div class="status-prompt">
        <div class="status-prompt-past">
          <p></p>
          <span>审批完成节点</span>
        </div>
        <div class="status-prompt-current">
          <p></p>
          <span>当前审批节点</span>
        </div>
        <div class="status-prompt-hang">
          <p></p>
          <span>未审批节点</span>
        </div>
      </div>
      <div class="activiti-details">
        <div class="bpmn-canvas" ref="canvas"></div>
        <!-- 工具栏显示的地方 -->
        <div class="bpmn-js-properties-panel" id="js-properties-panel"></div>
      </div>
    </div>
    <!-- 审批轨迹表格 -->
    <approval-track :getHighLine="getHighLine"></approval-track>
  </div>
</template>

<script>
import BpmnModeler from 'bpmn-js/lib/Modeler'
// 工具栏相关
import propertiesProviderModule from 'bpmn-js-properties-panel/lib/provider/camunda'
import propertiesPanelModule from 'bpmn-js-properties-panel'
import camundaModdleDescriptor from 'camunda-bpmn-moddle/resources/camunda'
// 汉化
import customTranslate from '@/avtiviti/customTranslate'
import ApprovalTrack from '@/views/FixedAssets/components/approvalTrack.vue'
import {
  getDefinitionXML,
  gethighLineProcess,
  getDefinitionXMLByProcessInstanceId
} from '@/http/url'
export default {
  props: ['approvalChartData'],
  components: {
    ApprovalTrack
  },
  data() {
    return {
      bpmnModeler: null,
      canvas: null,
      bpmnTemplate: '',
      activitiTaskid: [],
      getHighLine: [],
      aSpin: true,
      zoomNum: Number(1)
    }
  },
  activated() {
    // 默认渲染 审批流图
    const params = {
      processInstanceId: this.approvalChartData.processInstanceId
    }
    getDefinitionXMLByProcessInstanceId(params).then((res) => {
      if (res.status === 200) {
        this.bpmnTemplate = res.data
        this.gethighLineProcessFn()
      }
    })
    // const params = {
    //   taskId: this.approvalChartData.taskId
    // }
    // getDefinitionXML(params).then((res) => {
    //   this.bpmnTemplate = res.data
    //   this.gethighLineProcessFn()
    // })
  },
  created() {},
  mounted() {},
  methods: {
    // 缩放
    zommBpmn(type) {
      let defaultNum = Number(0.1)
      let jsPropertiesPanel = document
        .getElementById('oa-activiti')
        .getElementsByTagName('svg')[4]
      if (type === 'large') {
        if (this.zoomNum.toFixed(1) === '2.0') {
          this.$message.warning('已是最大缩放视图区域,无法再进行放大')
        } else {
          this.zoomNum += defaultNum
        }
      } else if (type === 'small') {
        if (this.zoomNum === 1) {
          this.$message.warning('已是最小缩放视图区域,无法再进行缩小')
        } else {
          this.zoomNum -= defaultNum
        }
      } else {
        this.zoomNum = 1
        let canvas = this.bpmnModeler.get('canvas')
        canvas.zoom('fit-viewport', 'auto')
      }
      jsPropertiesPanel.style.transform = 'scale(' + this.zoomNum + ')'
    },
    // 审批流高亮
    async gethighLineProcessFn() {
      const params = {
        processInstanceId: this.approvalChartData.processInstanceId
      }
      gethighLineProcess(params).then((res) => {
        if (res.data.code === 0) {
          this.aSpin = false
          this.getHighLine = res.data.data
          this.init()
        }
      })
    },
    async init() {
      // 获取画布 element
      this.canvas = this.$refs.canvas
      // 将汉化包装成一个模块
      const customTranslateModule = {
        translate: ['value', customTranslate]
      }
      // 创建Bpmn对象
      this.bpmnModeler = new BpmnModeler({
        // 设置bpmn的绘图容器为上门获取的画布 element
        container: this.canvas,
        // 加入工具栏支持
        propertiesPanel: {
          parent: '#js-properties-panel'
        },
        additionalModules: [
          propertiesProviderModule,
          propertiesPanelModule,
          // 汉化模块
          customTranslateModule,
          {
            paletteProvider: ['value', ''],
            labelEditingProvider: ['value', ''],
            contextPadProvider: ['value', ''],
            bendpoints: ['value', {}],
            zoomScroll: ['value', '']
            // moveCanvas: ['value', '']
          }
        ],
        moddleExtensions: {
          activiti: camundaModdleDescriptor
        }
      })
      await this.createNewDiagram(this.bpmnTemplate)
      const elementRegistry = this.bpmnModeler.get('elementRegistry')
      // highLine	高亮连线ID	array	string
      // highPoint	高亮节点ID	array	string
      // ido		array	string
      // waitingToDo	待办高亮节点
      let modeling = this.bpmnModeler.get('modeling')
      let highLineArr = []
      let highPointArr = []
      let waitingToDoArr = []
      // 过滤高亮线 为null处理
      let filterLineNull = this.getHighLine.highLine.filter(
        (isNull) => isNull != null
      )
      filterLineNull.forEach((items, ins) => {
        this.highLine = elementRegistry.filter((item) => item.id === items)
        highLineArr.push(this.highLine)
        modeling.setColor(highLineArr[ins], {
          stroke: 'green'
        })
      })
      // 已办
      this.getHighLine.highPoint.forEach((items, ins) => {
        this.highPoint = elementRegistry.filter((item) => item.id === items)
        highPointArr.push(this.highPoint)
        modeling.setColor(highPointArr[ins], {
          stroke: 'green'
          // fill: '#96c1ac'
        })
      })
      // 当前
      this.getHighLine.waitingToDo.forEach((items, ins) => {
        this.waitingToDo = elementRegistry.filter((item) => item.id === items)
        waitingToDoArr.push(this.waitingToDo)
        modeling.setColor(waitingToDoArr[ins], {
          stroke: '#0278fe'
          // fill: '#0278fe'
        })
      })
    },
    async createNewDiagram(bpmn) {
      // 将字符串转换成图显示出来;
      this.bpmnModeler.importXML(bpmn, (err) => {
        if (err) {
          // this.$Message.error('打开模型出错,请确认该模型符合Bpmn2.0规范')
        } else {
          // console.log(bpmn)
          let canvas = this.bpmnModeler.get('canvas')
          canvas.zoom('fit-viewport', 'auto')
        }
      })
    }
  }
}
</script>

<style scoped>
.oa-activiti {
  height: auto;
  /* overflow: hidden; */
}
.activiti-details {
  height: 60vh;
  overflow: hidden;
  background: #fff;
  margin-bottom: 20px;
  clear: both;
}
.bpmn-canvas {
  width: 100%;
  height: 100%;
}
/* /deep/ .bpmn-canvas .viewport {
  transform: matrix(1, 0, 0, 1, -250, -150) !important;
} */
#js-properties-panel {
  display: none;
}
/deep/ .bjs-powered-by {
  display: none !important;
}
.activiti-title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  overflow: hidden;
  text-indent: 2em;
  background: #fff;
  color: #333;
  font-weight: 700;
  font-size: 16px;
  border-bottom: 2px solid #f5f5f5;
}
.activit-select {
  display: flex;
  height: auto;
  overflow: hidden;
  margin: 20px;
}
.select-title {
  line-height: 35px;
}
.select-contion {
  height: auto;
  overflow: hidden;
}
.status-prompt {
  height: auto;
  overflow: hidden;
  display: flex;
  line-height: 16px;
  justify-content: flex-end;
}
.status-prompt-category {
  height: auto;
  overflow: hidden;
}
.status-prompt-past,
.status-prompt-current,
.status-prompt-hang {
  margin: 0 10px;
}
.status-prompt-past p,
.status-prompt-current p,
.status-prompt-hang p {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  float: left;
  margin-right: 10px;
}
.status-prompt-past p {
  background: green;
}
.status-prompt-current p {
  background: #0278fe;
}
.status-prompt-hang p {
  background: #000000;
}
.activiti-spin {
  position: absolute !important;
  left: 45% !important;
  top: 45% !important;
  z-index: 100 !important;
}
.zoom-activiti {
  float: left;
  height: auto;
  overflow: hidden;
  display: flex;
  margin-top: -10px;
}
</style>



// WEBPACK FOOTER //
// src/components/approval-chart/index.vue